import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "@/data/content";

export const MarqueeBand = () => (
  <section aria-hidden="true" className="py-10 md:py-16 border-y border-[rgba(28,27,26,0.1)] overflow-hidden">
    <Marquee speed={40} gradient={false} autoFill>
      {MARQUEE_WORDS.map((w) => (
        <span key={w} className="flex items-center">
          <span className="font-display stroke-text text-6xl md:text-8xl font-black tracking-tight px-6">{w}</span>
          <span className="text-[#e24a29] text-4xl md:text-6xl px-2">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
